import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';

function getBaseImageBoxStyles(isHorizontalView?: boolean) {
  return isHorizontalView
    ? `
      width: 60px;
      height: 60px;
      border-radius: 16px;
      margin-bottom: 5px;

      @media (min-width: 950px) {
        width: 95px;
        height: 95px;
        border-radius: 21px;
      }
    `
    : `
      width: 40px;
      height: 40px;
      border-radius: 7px;
      padding: 2px;
    `;
}

const HorizontalGridView = css`
  width: min-content;
  min-width: 80px;

  @media (min-width: 950px) {
    min-width: 105px;
  }
`;

const DefaultGridView = css`
  display: grid;
  grid-template-columns: 40px auto;
  gap: 15px;
  overflow: hidden;
`;

export const ImgBox = styled.div.attrs({ className: 'img-box' })<{
  $isHorizontalView?: boolean;
}>`
  ${({ $isHorizontalView }) => getBaseImageBoxStyles($isHorizontalView)};
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.secondary.background};
  overflow: hidden;

  img {
    object-fit: contain;
  }
`;

export const Texts = styled.div`
  overflow: hidden;
`;

export const GridItemTitle = styled(Typography.Caption)`
  text-align: center;
  color: ${({ theme }) => theme.palette.primary.labels};

  @media (min-width: 950px) {
    font-size: 14px;
  }
`;

export const ItemTitle = styled(Typography.Body)`
  margin-bottom: 3px;
`;

export const ItemDescription = styled(Typography.Caption)`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
`;

export const ImageSkeletonLoader = styled(SkeletonLoader)<{
  $isHorizontalView?: boolean;
}>`
  ${({ $isHorizontalView }) => getBaseImageBoxStyles($isHorizontalView)};
`;

export const Box = styled.div<{ $isHorizontalView?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  ${({ $isHorizontalView }) =>
    $isHorizontalView ? HorizontalGridView : DefaultGridView}

  &:hover {
    .img-box {
      background-color: ${({ theme }) => theme.palette.tertiary.background};
    }
    p {
      color: ${({ theme }) => theme.palette.brand.main};
    }
  }
`;

export const TextSkeletonLoader = styled(SkeletonLoader)`
  &:not(:last-child) {
    margin-bottom: 3px;
  }
`;
